import ReportList from 'components/containers/ReportList';
import LoginLogoutLayout from 'layouts/LoginLogout';
import withTilstandsrapport from 'lib/withTilstandsrapport';
import { NextPage } from 'next';

import Head from 'next/head';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { AppState } from 'store';
import { doFetchChatByTilstandsrapportId } from 'store/chat/actions';
import { getAddress } from 'store/tilstandsrapportEntities/tilstandsrapport/selectors';

interface Props {
  tilstandsrapportId: string;
  doFetchByTilstandsrapportId: Function;
}

interface StateProps {
  address: string;
}

const PageList: NextPage<Props> = ({ address, tilstandsrapportId,  doFetchByTilstandsrapportId: fetchChat,}: Props & StateProps) => {
  const typeformSbaSurveyStatusKey = 'typeform-sba-survey-status';
  const router = useRouter();

  const handleFetchChat = async (id: string): Promise<void> => {
    return fetchChat(id);
  };

  useEffect(() => {
    handleFetchChat(tilstandsrapportId)
  }, [tilstandsrapportId]);

  // Run effect for opening Typeform survey when the user navigates to a different page
  useEffect(() => {
    const typeformSbaSurveyStatus = localStorage.getItem(typeformSbaSurveyStatusKey);

    if (typeformSbaSurveyStatus === 'SEEN') {
      return;
    }

    const openPopup = popupReference => {
      localStorage.setItem(typeformSbaSurveyStatusKey, 'SEEN');
      popupReference.open();
    };

    const routeChangeStart = url => {
      if (!url.includes('utbedringsplan') && localStorage.getItem(typeformSbaSurveyStatusKey) === 'ELIGIBLE') {
        /** @ts-ignore */
        if (!(window.typeformEmbed && window.typeformEmbed.makePopup)) {
          return;
        }
        /** @ts-ignore */
        const popupReference = window.typeformEmbed.makePopup('https://admin.typeform.com/to/vv1PeL4O', {
          autoOpen: false,
          mode: 'popup',
        });
        openPopup(popupReference);
      }
    };

    router.events.on('routeChangeStart', routeChangeStart);

    // eslint-disable-next-line consistent-return
    return () => {
      router.events.off('routeChangeStart', routeChangeStart);
    };
  }, [router.asPath, router.events]);

  // Run effect after mounted for preparing showing survey popup if the user spends some time on this page.
  useEffect(() => {
    const typeformSbaSurveyStatus = localStorage.getItem(typeformSbaSurveyStatusKey);

    if (typeformSbaSurveyStatus) {
      return;
    }

    let fireTypeformTimeout;
    const setIsEligibleForSurvey = () => {
      localStorage.setItem(typeformSbaSurveyStatusKey, 'ELIGIBLE');
      clearTimeout(fireTypeformTimeout);
    };

    fireTypeformTimeout = setTimeout(() => setIsEligibleForSurvey(), 5000);
  }, []);

  return (
    <LoginLogoutLayout>
      <Head>
        <title>{`${address} - Vendu Smart Boliganalyse`}</title>
      </Head>
      <ReportList tilstandsrapportId={tilstandsrapportId} />
    </LoginLogoutLayout>
  );
};

const mapStateToProps = (state: AppState, ownProps): StateProps => ({
  address: getAddress(state, ownProps.tilstandsrapportId),
});

export default withTilstandsrapport(
  connect<StateProps, {}, Props>(
    mapStateToProps,
    {  doFetchByTilstandsrapportId: doFetchChatByTilstandsrapportId,},

  )(PageList),
);
